const state = {
  searchParams: JSON.parse(sessionStorage.getItem('searchParams')) || {
    route: null,
    mainaData: {},
    extraData: {},
    isExpanded: null,
  },
  listParams: JSON.parse(sessionStorage.getItem('listParams')) || {
    pageSize: null,
    page: null,
    route: null
  },
  sortParams: JSON.parse(sessionStorage.getItem('sortParams')) || {
    show: false,
    sort: null,
    direction: null,
    sortDesc: null,
    route: null
  },
}
const getters = {
  searchParams: state => state.searchParams,
  listParams: state => state.listParams,
  sortParams: state => state.sortParams,
}
const actions = {
  searchParams({ commit }, payload) {
    commit('searchParams', payload)
    sessionStorage.setItem('searchParams', JSON.stringify(payload))
  },
  listParams({ commit }, payload) {
    commit('listParams', payload)
    sessionStorage.setItem('listParams', JSON.stringify(payload))
  },
  sortParams({ commit }, payload) {
    commit('sortParams', payload)
    sessionStorage.setItem('sortParams', JSON.stringify(payload))
  },
}
const mutations = {
  searchParams(state, data) {
    state.searchParams = data
  },
  listParams(state, data) {
    state.listParams = data
  },
  sortParams(state, data) {
    state.sortParams = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
